import { render, staticRenderFns } from "./PretestSituation.vue?vue&type=template&id=59514ac1&scoped=true&lang=pug&"
import script from "./PretestSituation.vue?vue&type=script&lang=ts&"
export * from "./PretestSituation.vue?vue&type=script&lang=ts&"
import style0 from "./PretestSituation.vue?vue&type=style&index=0&id=59514ac1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59514ac1",
  null
  
)

export default component.exports